import { END_POINTS } from '@config';
import { api } from '@core/baseApi';
import { HTTPResponse } from '@types';

import {
  DailyListResponse,
  DailyPaymentVolume,
  DailyReportJobRequest,
  DailyReportType,
  DailySettlement,
  DashboardQueryRequest
} from '../types';

const DAILY_REPORT_JOB_URL = {
  [DailyReportType.COLLECTION]: END_POINTS.DASHBOARD.GET_COLLECTION_REPORT_JOB,
  [DailyReportType.SETTLEMENT]: END_POINTS.DASHBOARD.GET_SETTLEMENT_REPORT_JOB
};

const extendedBaseQuery = api.injectEndpoints({
  endpoints: (builder) => ({
    getBranchRevenue: builder.query<
      HTTPResponse<any>,
      { organizationId: string; queryString: string }
    >({
      query: (req) => ({
        url: `${END_POINTS.DASHBOARD.GET_BRANCH_REVENUE(req.organizationId)}${
          req.queryString || ''
        }`,
        method: 'GET'
      })
    }),
    getGroupPerfomance: builder.query<
      HTTPResponse<any>,
      { organizationId: string; queryString: string }
    >({
      query: (req) => ({
        url: `${END_POINTS.DASHBOARD.GET_GROUP_PERFOMANCE(req.organizationId)}${
          req.queryString || ''
        }`,
        method: 'GET'
      })
    }),
    getPaymentLinksAndModes: builder.query<
      HTTPResponse<any>,
      { organizationId: string; queryString: string }
    >({
      query: (req) => ({
        url: `${END_POINTS.DASHBOARD.GET_PAYMENT_LINKS_AND_MODES(
          req.organizationId
        )}${req.queryString || ''}`,
        method: 'GET'
      })
    }),
    getPaymentOverview: builder.query<
      HTTPResponse<any>,
      { orgId: string; queryString: string }
    >({
      query: (req) => ({
        url: `${END_POINTS.DASHBOARD.GET_PAYMENT_OVERVIEW(req.orgId)}${
          req.queryString
        }`,
        method: 'GET'
      })
    }),
    getPaymentVolume: builder.query<
      DailyListResponse<DailyPaymentVolume>,
      DashboardQueryRequest
    >({
      query: (req) => ({
        url: `${END_POINTS.DASHBOARD.GET_PAYMENT_VOLUME(req.organizationId)}${
          req.queryString
        }`,
        method: 'GET'
      }),
      keepUnusedDataFor: 0
    }),
    getSettlementBreakdown: builder.query<
      DailyListResponse<DailySettlement>,
      DashboardQueryRequest
    >({
      query: (req) => ({
        url: `${END_POINTS.DASHBOARD.GET_SETTLEMENT_BREAKDOWN(
          req.organizationId
        )}${req.queryString}`,
        method: 'GET'
      }),
      keepUnusedDataFor: 0
    }),
    getDailyReportJob: builder.query<{ job_id: string }, DailyReportJobRequest>(
      {
        query: (req) => ({
          url: `${DAILY_REPORT_JOB_URL[req.reportType](req.organizationId)}${
            req.queryString
          }`,
          method: 'GET'
        })
      }
    )
  })
});

// eslint-disable-next-line import/prefer-default-export
export const {
  useLazyGetBranchRevenueQuery,
  useLazyGetGroupPerfomanceQuery,
  useLazyGetPaymentLinksAndModesQuery,
  useLazyGetPaymentOverviewQuery,
  useGetPaymentVolumeQuery,
  useGetSettlementBreakdownQuery,
  useLazyGetDailyReportJobQuery
} = extendedBaseQuery;
